export default "__VITE_ASSET__DN0FkafQ__"